import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

import store from '../store';

export default class WrappedBase extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <IntlProvider locale="en">{this.props.children}</IntlProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/wrapped/WrappedBase.js